(function () {
  /* =========================================================
   * GUARD GLOBAL: solo corre en el producto Probioticos Suscripción
   * =======================================================*/
  const TARGET_HANDLE = 'probioticos-naraa-suscripcion';
  if (!window.location.pathname.includes('/products/' + TARGET_HANDLE)) return;

  console.log('Run custom probiotics');

  // Variante única para compra única (lo que cambia es la cantidad, no la variante)
  const SINGLE_VARIANT_ID = 53756875571514;

  // Cantidad a agregar / cantidad esperada según la option activa
  const QTY_BY_OPTION = {
    '1': 1,
    '2': 2,
    '3': 3,
  };


  /* =========================================================
   * Helpers compartidos: option / plan / suscripción activos
   * =======================================================*/
  function getActiveOption() {
    const opt = document.querySelector(
      '.product__variants .product__option[data-instant-state="active"]'
    );
    if (!opt) return null;
    if (opt.classList.contains('product__option-1')) return '1';
    if (opt.classList.contains('product__option-2')) return '2';
    if (opt.classList.contains('product__option-3')) return '3';
    return null;
  }

  function getActivePlan() {
    return document.querySelector('.custom-plan-selected')?.dataset.plan || null;
  }

  function isSubscriptionActive() {
    return !!document.querySelector('.custom-subscriptions-two.active');
  }


  /* =========================================================
   * 1. Toggle Compra única / Suscripción
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const one = document.querySelector('.custom-subscriptions-one');
    const two = document.querySelector('.custom-subscriptions-two');
    if (!one || !two) return;

    function syncPdpClass() {
      const pdp = document.querySelector('.custom-subs-pdp');
      if (!pdp) return;
      const isPlan = !!document.querySelector('.custom-subscriptions-two.active');
      pdp.classList.toggle('is-plan', isPlan);
    }

    function select(active, inactive) {
      active.classList.add('active');
      inactive.classList.remove('active');
      syncPdpClass();
      document.dispatchEvent(new CustomEvent('subscription:change'));
    }
    one.addEventListener('click', () => select(one, two));
    two.addEventListener('click', () => select(two, one));

    syncPdpClass();
  });

  /* =========================================================
   * 2. Dropdown de plan (data-plan = '1' | '2')
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const selected = document.querySelector('.custom-plan-selected');
    const plans = document.querySelectorAll('.custom-plan-1, .custom-plan-2');
    if (!selected || !plans.length) return;

    function setInitialPlan() {
      const selectedText = selected.querySelector('p')?.textContent?.trim();
      const plan1Text = document.querySelector('.custom-plan-1 p')?.textContent?.trim();
      selected.dataset.plan = selectedText === plan1Text ? '1' : '2';
    }
    setInitialPlan();

    plans.forEach(plan => {
      plan.addEventListener('click', function () {
        const text = plan.querySelector('p')?.textContent?.trim();
        if (text) selected.querySelector('p').textContent = text;
        selected.dataset.plan = plan.classList.contains('custom-plan-1') ? '1' : '2';
      });
    });
  });

  /* =========================================================
   * 4. Interceptor del ATC -> URL de Treli según plan + option
   *    (sin sabores: una sola URL por combinación plan/option)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {

    const TRELI_URLS = {
      '1': { // ===== PLAN 1 (mensual) =====
        '1': 'https://checkout.treli.co/pl/pl_XIsFuFDgT8UGBA51uL0S45f2?quantity=1', // Plan 1 - option-1
        '2': 'https://checkout.treli.co/pl/pl_i2cNY5Umen7Eegxc9JRjKZiT?quantity=2', // Plan 1 - option-2
        '3': 'https://checkout.treli.co/pl/pl_i60qmb7X0lGnFXNbPwqBIg4K?quantity=3', // Plan 1 - option-3
      },
      '2': { // ===== PLAN 2 (bimensual) =====
        '1': 'https://checkout.treli.co/pl/pl_j57rYmF6LHV8D9EhT9n27yUI?quantity=1', // Plan 2 - option-1
        '2': 'https://checkout.treli.co/pl/pl_AOapQqHxKZQlqblUqGH7aHFM?quantity=2', // Plan 2 - option-2
        '3': 'https://checkout.treli.co/pl/pl_n76Rc59G7XXMLo6jta09B8Yo?quantity=3', // Plan 2 - option-3
      },
    };

    function handleAtcClick(e) {
      if (!isSubscriptionActive()) return; // compra única -> flujo normal (bloque X)

      // A partir de aquí SIEMPRE es suscripción: bloqueamos el flujo nativo
      // para que NUNCA agregue al carrito, pase lo que pase.
      e.preventDefault();
      e.stopImmediatePropagation();

      const plan = getActivePlan();
      const option = getActiveOption();
      if (!plan || !option) {
        console.warn('Treli: plan u option no detectados', { plan, option });
        return;
      }

      const url = TRELI_URLS[plan]?.[option];
      if (!url || url === 'PON_AQUI_URL') {
        console.warn('Treli: falta link para', plan, option);
        return;
      }

      window.location.href = url;
    }

    const atcBtn = document.querySelector('.atc__btn');
    if (atcBtn) atcBtn.addEventListener('click', handleAtcClick, true);
  });


  /* =========================================================
   * 5. Sufijo "(Cada Mes)" en los títulos de opción (solo suscripción)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const SUFFIX = ' (Cada Mes)';

    function refreshTitles() {
      const isSub = !!document.querySelector('.custom-subscriptions-two.active');
      const titles = document.querySelectorAll('.product__option-title p');

      titles.forEach(p => {
        if (p.dataset.baseHtml === undefined) p.dataset.baseHtml = p.innerHTML;

        const hasSuffix = p.innerHTML.trimEnd().endsWith(SUFFIX.trim());

        if (isSub && !hasSuffix) {
          p.innerHTML = p.dataset.baseHtml + SUFFIX;
        } else if (!isSub && hasSuffix) {
          p.innerHTML = p.dataset.baseHtml;
        }
      });
    }

    refreshTitles();
    document.addEventListener('subscription:change', refreshTitles);
  });


  /* =========================================================
   * 6. Precio según la option activa (solo suscripción)
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const PRICES = {
      '1': '$101.150', // option-1  (ajusta al precio real de probióticos)
      '2': '$89.100',  // option-2
      '3': '$80.100',  // option-3
    };

    function refreshPrice() {
      const priceEl = document.querySelector('.custom-selected-price-plan p');
      if (!priceEl) return;

      const option = getActiveOption();
      if (option && PRICES[option]) {
        priceEl.textContent = PRICES[option];
      }
    }

    // Actualiza al cambiar de option (Instant cambia data-instant-state)
    const variantsWrap = document.querySelector('.product__variants');
    if (variantsWrap) {
      const obs = new MutationObserver(refreshPrice);
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        obs.observe(opt, { attributes: true, attributeFilter: ['data-instant-state'] });
      });
    }

    refreshPrice(); // estado inicial
  });


  /* =========================================================
   * 7. .custom-pdp-price span = precio del plan cuando hay suscripción
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const pdpEl = document.querySelector('.custom-pdp-price');
    const planP = document.querySelector('.custom-selected-price-plan p');
    if (!pdpEl || !planP) return;

    let basePrice;        // precio compra única, se fija en el primer span válido
    let isWriting = false; // evita loop con nuestro propio self-observer

    function getSpan() {
      return pdpEl.querySelector('span'); // se re-resuelve por si Instant lo recreó
    }

    function desiredPrice() {
      if (isSubscriptionActive()) {
        return planP.textContent.trim() || basePrice;
      }
      return basePrice;
    }

    function refreshPdpPrice() {
      const span = getSpan();
      if (!span) return;

      // Fijamos el precio base la primera vez que hay un span con valor
      if (basePrice === undefined) {
        const t = span.textContent.trim();
        if (t) basePrice = t;
      }

      const value = desiredPrice();
      if (!value || span.textContent.trim() === value) return;

      isWriting = true;
      span.textContent = value;
      // liberar en microtask, no en rAF: el observer #4 dispara en el mismo tick
      Promise.resolve().then(() => { isWriting = false; });
    }

    // 1) Toggle Compra única / Suscripción
    document.addEventListener('subscription:change', refreshPdpPrice);

    // 2) Cambio de option activa (data-instant-state)
    const variantsWrap = document.querySelector('.product__variants');
    if (variantsWrap) {
      const obs = new MutationObserver(refreshPdpPrice);
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        obs.observe(opt, { attributes: true, attributeFilter: ['data-instant-state'] });
      });
    }

    // 3) Cuando la sección 6 reescribe el plan-price (p)
    new MutationObserver(function () {
      if (isSubscriptionActive()) refreshPdpPrice();
    }).observe(planP, { childList: true, characterData: true, subtree: true });

    // 4) Cuando Instant repinta el span, lo corregimos (observamos el PADRE)
    new MutationObserver(function () {
      if (isWriting) return;
      refreshPdpPrice();
    }).observe(pdpEl, { childList: true, characterData: true, subtree: true });

    // 5) El bloque nativo de Instant escribe el precio de la VARIANTE en
    //    .custom-pdp-price al hacer click en una option. En suscripción
    //    volvemos a imponer el precio del plan, DESPUÉS de ese script.
    if (variantsWrap) {
      variantsWrap.querySelectorAll('.product__option').forEach(opt => {
        opt.addEventListener('click', function () {
          if (!isSubscriptionActive()) return;
          requestAnimationFrame(refreshPdpPrice);
          setTimeout(refreshPdpPrice, 0);
        });
      });
    }

    refreshPdpPrice(); // inicial
  });

  /* =========================================================
   * 8. Precio /DÍA de cada option según el plan (1 mes vs 2 meses)
   *    Plan 2 (cada 2 meses) -> el costo/día se divide entre 2
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    // Formatea un número entero a formato COP: 1685 -> "$1.685"
    function formatCOP(num) {
      return '$' + Math.round(num).toLocaleString('es-CO');
    }

    // Extrae el entero desde "$1.685/DÍA" -> 1685 (quita $, puntos y texto)
    function parseCOP(text) {
      const digits = text.replace(/[^\d]/g, '');
      return parseInt(digits, 10) || 0;
    }

    // El sufijo que acompaña al número (ej. "/DÍA")
    function getSuffix(text) {
      const m = text.match(/[\d.]+\s*(.*)$/);
      return m ? m[1] : '';
    }

    function getActivePlanLocal() {
      return document.querySelector('.custom-plan-selected')?.dataset.plan || '1';
    }

    // Recolecta los badges /DÍA (los .white-badge de cada option)
    const badges = Array.from(
      document.querySelectorAll('.product__variants .product__option .product__info--badge.white-badge')
    );

    // Guardamos el valor BASE (plan 1) de cada badge una sola vez
    badges.forEach(b => {
      if (b.dataset.baseDia === undefined) {
        b.dataset.baseDia = String(parseCOP(b.textContent));
        b.dataset.suffix = getSuffix(b.textContent.trim());
      }
    });

    function refreshDiaBadges() {
      const plan = getActivePlanLocal();
      const divisor = plan === '2' ? 2 : 1;

      badges.forEach(b => {
        const base = parseInt(b.dataset.baseDia, 10) || 0;
        if (!base) return;
        const suffix = b.dataset.suffix || '/DÍA';
        b.textContent = ' ' + formatCOP(base / divisor) + suffix + ' ';
      });
    }

    // 1) Al cambiar de plan en el dropdown (.custom-plan-1 / .custom-plan-2)
    document.querySelectorAll('.custom-plan-1, .custom-plan-2').forEach(plan => {
      plan.addEventListener('click', function () {
        requestAnimationFrame(refreshDiaBadges);
        setTimeout(refreshDiaBadges, 0);
      });
    });

    refreshDiaBadges(); // estado inicial
  });


  /* =========================================================
   * X. Compra única: agregar SIEMPRE la misma variante,
   *    variando solo la CANTIDAD según la option (1/2/3).
   *    Luego refrescar el drawer de Instant vía su API interna.
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const atcBtn = document.querySelector('.atc__btn');
    if (!atcBtn) return;

    atcBtn.addEventListener('click', function (e) {
      if (isSubscriptionActive()) return;  // suscripción -> bloque 4 (Treli)

      const option = getActiveOption();
      if (!option) return;

      const quantity = QTY_BY_OPTION[option];
      if (!quantity) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      const items = [{ id: SINGLE_VARIANT_ID, quantity: quantity }];

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(r => r.json())
        .then((cart) => {
          console.log('cart add', cart);
          // Refresca el drawer de Instant con su API interna (sin recargar)
          if (window.Instant?.api?.updateCart) {
            return window.Instant.api.updateCart();
          }
        })
        .then(() => {
          // Abre el drawer
          if (window.Instant?.api?.toggleCart) {
            window.Instant.api.toggleCart();
          }
        })
        .catch(err => {
          console.error('Error agregando al carrito:', err);
          const href = atcBtn.getAttribute('href');
          if (href) window.location.href = href;
        });
    }, true);
  });


  /* =========================================================
   * Y. Al cargar con ?open_cart=1, abrir el cart drawer de Instant
   * =======================================================*/
  (function () {
    const params = new URLSearchParams(window.location.search);
    if (params.get('open_cart') !== '1') return;

    params.delete('open_cart');
    const clean = window.location.pathname +
      (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', clean);

    let done = false; // candado: solo un click en toda la vida del script
    let tries = 0;
    const maxTries = 60;

    function attempt() {
      if (done) return;

      const trigger = document.querySelector('.custom-cart-toggle');
      if (trigger) {
        done = true;
        trigger.click();
        return;
      }

      if (++tries < maxTries) {
        setTimeout(attempt, 150);
      }
    }

    window.addEventListener('load', function () {
      setTimeout(attempt, 500);
    });
  })();


  /* =========================================================
   * W. Frecuencia "(Cada Mes)" / "(Cada 2 Meses)" en cada
   *    .product__option-title según el plan activo (.custom-plan-1/2)
   *    Solo aplica en modo suscripción.
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    const titles = Array.from(document.querySelectorAll('.product__option-title p'));
    if (!titles.length) return;

    titles.forEach(p => {
      if (p.dataset.baseTitle === undefined) {
        const base = p.getAttribute('data-base-html')
          || p.innerHTML.replace(/\s*\(Cada[^)]*\)\s*$/i, '');
        p.dataset.baseTitle = base.trim();
      }
    });

    function getFrecuencia() {
      const plan2Active = document.querySelector('.custom-plan-2.custom-plan-active, .custom-plan-2.active');
      const selectedTxt = document.querySelector('.custom-plan-selected p')?.textContent || '';
      const isPlan2 = plan2Active || /2\s*Meses/i.test(selectedTxt);
      return isPlan2 ? 'Cada 2 Meses' : 'Cada Mes';
    }

    function refreshTitles() {
      const sub = isSubscriptionActive();
      const frec = getFrecuencia();

      titles.forEach(p => {
        const base = p.dataset.baseTitle;
        if (sub) {
          const nuevo = base + ' (' + frec + ')';
          if (p.innerHTML !== nuevo) p.innerHTML = nuevo;
        } else {
          if (p.innerHTML !== base) p.innerHTML = base;
        }
      });
    }

    document.querySelectorAll('.custom-plan-1, .custom-plan-2').forEach(el => {
      el.addEventListener('click', function () {
        requestAnimationFrame(refreshTitles);
        setTimeout(refreshTitles, 0);
      });
    });

    document.addEventListener('subscription:change', refreshTitles);

    refreshTitles(); // inicial
  });


  /* =========================================================
   * Z. Al alternar suscripción/compra única, re-disparar la option
   *    activa para que el Liquid recalcule el .product__save.
   * =======================================================*/
  document.addEventListener('DOMContentLoaded', function () {
    document.addEventListener('subscription:change', function () {
      const active = document.querySelector(
        '.product__variants .product__option[data-instant-state="active"]'
      );
      if (active) {
        requestAnimationFrame(() => active.click());
      }
    });
  });

  
})();